/* eslint no-console: 0 */

import Vue from 'vue'
import Lodges from '../lodges_index.vue'

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector("#lodges");
  const app = new Vue({
    el,
    render(h){
      return h(Lodges, {
        props: {
            urls: JSON.parse(el.dataset.urls),
            region: el.dataset.region,
            regions: JSON.parse(el.dataset.regions),
            parks: JSON.parse(el.dataset.parks),
            wknd: el.dataset.wknd,
            searchLink: el.dataset.search,
            params: JSON.parse(el.dataset.params),
            config: JSON.parse(el.dataset.config)
        }
      });
    }
  });
});
